import { BaseEntityDto } from '@fleet-beat/core';

export interface GetFmcsaReportsDto extends BaseEntityDto {
  driverId?: string;
  dateRange?: string;
  companyIds?: string;
  limit?: number;
  offset?: number;
  search?: string;
}
